import { Link } from "react-router-dom";
import { useTranslation } from 'react-i18next';


export default function MasarAddress() {
    const { t, i18n } = useTranslation();

    return (
        <>
            <Link
                to={`/${i18n.language}/contact-us`}
            >
                <h6>{t("Contact Us")}</h6>
            </Link>
            {i18n.language === "ar" ?
                <address className="pt-2 pb-2">
                    ٢٨٨٩، طريق الأمير سعد بن عبدالرحمن الأول
                    <br />
                    الرياض - المملكة العربية السعودية<br />
                    ٥٠٨٦٨٤٧٩٥ (٩٦٦+)
                </address>
                :
                <address className="pt-2 pb-2">
                    2889 Prince Saad Bin Abdulrahman Al-Awwal Road
                    <br />
                    Riyadh - Saudi Arabia
                    <br />
                    (+966) 508684795
                </address>
            }
        </>
    )

}